import { render, staticRenderFns } from "./ebs-cluster.component.vue?vue&type=template&id=0350a0e5&"
import script from "./ebs-cluster.component.vue?vue&type=script&lang=js&"
export * from "./ebs-cluster.component.vue?vue&type=script&lang=js&"
import style0 from "./ebs-cluster.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports